import React, { useContext } from 'react'

import { Config, IConfig } from '../Config'

export class ConfigData {
  config: Config

  constructor(config?: IConfig) {
    this.config = new Config(config?.config || { features: {} })
  }
}

export const ConfigContext = React.createContext<ConfigData>(new ConfigData())

export const useConfig = (): Config => {
  const { config } = useContext(ConfigContext)
  return config
}
